import { ReactNode } from "react";

interface PageTransitionProps {
    children: ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
    return (
        <div className="animate-fade-in">
            {children}
        </div>
    );
};

export default PageTransition;
